// Account assignments (operation templates). Representative entries for the demo.
export interface AccAssignmentFixture {
  id: number
  description: string
  action_type: number
  code: string
  is_active: boolean
  is_dma: boolean
}

export const accAssignmentsFixture: AccAssignmentFixture[] = [
  { id: 101, description: 'Purchase of services - 20% VAT', action_type: 2, code: 'PURCH-SVC-20', is_active: true, is_dma: true },
  { id: 102, description: 'Purchase of services - no VAT (foreign)', action_type: 2, code: 'PURCH-SVC-0', is_active: true, is_dma: true },
  { id: 103, description: 'Purchase of materials - 20% VAT', action_type: 2, code: 'PURCH-MAT-20', is_active: true, is_dma: false },
  { id: 104, description: 'Purchase of fixed assets', action_type: 2, code: 'PURCH-FA', is_active: true, is_dma: false },
  { id: 105, description: 'Reverse-charge VAT - intra-community acquisition', action_type: 2, code: 'RC-ICA', is_active: true, is_dma: true },
  { id: 201, description: 'Sale of services - 20% VAT', action_type: 1, code: 'SALE-SVC-20', is_active: true, is_dma: true },
  { id: 202, description: 'Sale of services - exempt', action_type: 1, code: 'SALE-SVC-EX', is_active: true, is_dma: false },
  { id: 203, description: 'Sale of goods - 20% VAT', action_type: 1, code: 'SALE-GD-20', is_active: true, is_dma: false },
  { id: 301, description: 'Bank fees', action_type: 2, code: 'BANK-FEE', is_active: true, is_dma: true },
  { id: 302, description: 'Foreign currency conversion', action_type: 2, code: 'FX-CONV', is_active: true, is_dma: false },
]
